import React, { Component } from 'react';
import { Carousel, Materialbox } from 'materialize-css';
import MetaDecorator from '../../services/MetaDecorator';
import AzureImage from '../../../media/images/azure.jpg';
import AzureMobileImage from '../../../media/images/azureMobile.jpg';
// import AzureImage1 from '../../../media/images/azure1.png';
// import AzureImage2 from '../../../media/images/azure2.png';
// import AzureImage3 from '../../../media/images/azure3.png';
// import AzureImage4 from '../../../media/images/azure4.png';
// import AzureImage5 from '../../../media/images/azure5.png';

export default class Azure extends Component {
    constructor(props) {
        super(props);
        this.tabsRef = React.createRef()
        this.carouselRef = React.createRef()
        this.state = {
            width: window.innerWidth
        };
    }

    componentDidMount() {
        let tabs = document.getElementsByClassName("nav-wrapper");
        if (tabs.length > 0) {
            tabs = tabs[1].querySelectorAll("ul")[0].querySelectorAll("a");
            for (let i = 0; i < tabs.length; i++) {
                tabs[i].removeAttribute('class');
                if (tabs[i].id === "scopes" || tabs[i].id === "azure") {
                    tabs[i].setAttribute('class', 'orange-text text-darken-4')
                }
            }
        }

        let mobileTabs = document.getElementsByClassName("sidenav");
        if (mobileTabs.length > 0) {
            mobileTabs = mobileTabs[0].querySelectorAll("a");
            for (let i = 0; i < mobileTabs.length; i++) {
                if (mobileTabs[i].id === "scopesMobile" || mobileTabs[i].id === "azureMobile") {
                    mobileTabs[i].removeAttribute('class');
                    mobileTabs[i].setAttribute('class', 'orange-text text-darken-4 grey darken-3')
                }
            }
        }

        var instance = Carousel.init(this.carouselRef.current);
        if (instance) {
            setInterval(() => {
                instance.next();
            }, 4000);
        }

        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions.bind(this));

        var imgs = document.querySelectorAll('.materialboxed');
        Materialbox.init(imgs);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth });
    }

    render() {
        const { width } = this.state;
        const isMobile = width <= 600;
        const isTablet = width <= 992 && width > 600;
        return (
            <React.Fragment>
                <MetaDecorator
                    title="JetMinds | Microsoft Azure Beratung, Konzeption, und Entwicklung"
                    descrption="Microsoft Azure Beratung, Konzeption, und Entwicklung: Microsoft Azure bietet die Möglichkeit, Cloud-basierte Dienste wie SaaS, PaaS und IaaS zu verwenden"
                    url="https://www.jetminds.de/fokusbereiche/microsoft-azure/" />
                <div className="pageImageTitle">
                    {isMobile ?
                        <img className="responsive-img" style={{ width: '100%' }} src={AzureMobileImage} alt="JetMinds Microsoft Azure" loading="lazy" /> :
                        <img className="responsive-img" style={{ width: '100%' }} src={AzureImage} alt="JetMinds Microsoft Azure" loading="lazy" />}
                    {isMobile || isTablet ?
                        <div className="imgTxtMobile">
                            <h1 className={`white-text ${isTablet ? "isTablet" : "isMobile"}`}>Azure</h1>
                        </div>
                        :
                        <div className="imgTxt">
                            <h1 className="white-text">Azure</h1>
                        </div>}
                </div><div className="container">
                    <div className="section">
                        <div className="row">
                            <div className="col s12 m12">
                                <h1 className={`${isMobile ? "pageTitleM" : "pageTitle"}`} >Innovative, <span className="orange-text text-darken-4">cloud-basierte</span> und hoch <span className="orange-text text-darken-4">skalierbare</span> Microsoft Azure-Produkte und -Dienste</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col s12 m12">
                                <p className="light">
                                    Unternehmen auf der ganzen Welt erzielen mit Geschäftslösungen, die auf Cloud basieren, große Erfolge. Sie definieren die Art und Weise, wie sie mit skalierbaren und sicheren Cloud-fähigen Unternehmensanwendungen Geschäfte machen, neu. Weltweit verwenden die meisten erfolgreichen Unternehmen Microsoft Azure, um ihre Geschäfte voranzutreiben. Mit integrierten Azure-Clouddiensten können Unternehmen schnell und einfach Infrastrukturen, Software und kleine als auch komplexe Lösungen entwickeln, bereitstellen und verwalten. In diesem Zusammenhang bieten wir Ihnen folgende Services an:
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                                <div className="icon-block">
                                    <h2 className="center orange-text text-darken-4"><i className="material-icons" style={{ fontSize: "35px" }}>battery_charging_full</i></h2>
                                    <h5 className="center">Beratung</h5>
                                    <p className="light">Als "Infrastructure as a Service" (IaaS) bietet Microsoft Azure die Möglichkeit, Cloud-basierte Dienste wie "Software as a Service" (SaaS) und "Platform as a Service" (PaaS) zu verwenden und unterstützt dabei eine breite Palette von Frameworks, Tools und Programmiersprachen, einschließlich sowohl Microsoft-Plattformen als auch Software und Systeme von Drittanbietern. Um die wachsende Sammlung integrierter Azure-Dienste effizient nutzen zu können, stehen wir Ihnen mit fundierter technischer sowie funktioneller Beratung zur Seite, damit Sie die spezifischen Vorteile von Microsoft Azure erkennen und in Ihr Unternehmen übertragen können.</p>
                                </div>
                            </div>
                            <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                                <div className="icon-block">
                                    <h2 className="center orange-text text-darken-4"><i className="material-icons" style={{ fontSize: "35px" }}>subject</i></h2>
                                    <h5 className="center">Konzeption</h5>
                                    <p className="light">Der wichtigste Schlüssel zum Erfolg in der Cloud-Welt ist die Erstellung eines Konzepts, das die Kontinuität und Skalierbarkeit der Lösungen sicherstellt. Unser Fokus zeichnet sich durch fundiertes technisches Wissen, hervorragende Kommunikationsfähigkeiten und Verantwortungsbewusstsein aus, das von der Projektplanung und -verwaltung der Azure-Transformation bis hin zur Definition eines klaren Konzepts reichen. Abhängig von den Anforderungen des Unternehmens sind wir auch am Design der Cloud-Architektur und -Infrastruktur beteiligt und können das technische Anforderungsmanagement übernehmen.</p>
                                </div>
                            </div>
                            <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                                <div className="icon-block">
                                    <h2 className="center orange-text text-darken-4"><i className="material-icons" style={{ fontSize: "35px" }}>done_all</i></h2>
                                    <h5 className="center">Umsetzung</h5>
                                    <p className="light">Wir sind Ihr Ansprechpartner für die Umsetzung zuverlässiger Web- und Mobillösungen sowie hochflexibler plattformübergreifender Apps. Unsere Erfahrungen helfen Firmen im Bereich Microsoft Azure Services sowie der Automatisierung von Geschäftsabläufen, der Rationalisierung von Prozessen und der Vereinfachung des Datenmanagements. Wir bringen in Ihr Unternehmen Innovation und Wachstum mit leistungsstarken Lösungen auf Basis von Microsoft Azure um den modernen Anforderungen in Ihrem Unternehmen gerecht zu werden und die Mitarbeiter zu motivieren. Lassen Sie uns über Ihre Anforderungen austauschen.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* {isMobile ?
                        <div className="section">
                            <div className="row">
                                <div className="col s12">
                                    <img className="responsive-img materialboxed" src={AzureImage1} alt="JetMinds Microsoft Azure" loading="lazy" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col s6">
                                    <img className="responsive-img materialboxed" src={AzureImage2} alt="JetMinds Microsoft Azure" loading="lazy" />
                                </div>
                                <div className="col s6">
                                    <img className="responsive-img materialboxed" src={AzureImage3} alt="JetMinds Microsoft Azure" loading="lazy" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col s6">
                                    <img className="responsive-img materialboxed" src={AzureImage4} alt="JetMinds Microsoft Azure" loading="lazy" />
                                </div>
                                <div className="col s6">
                                    <img className="responsive-img materialboxed" src={AzureImage5} alt="JetMinds Microsoft Azure" loading="lazy" />
                                </div>
                            </div>
                        </div> :
                        <div className="section">
                            <div className="row">
                                <div className="col s12 m12">
                                    <div className="carousel carousel-slider" style={{ height: "70vh" }} ref={this.carouselRef}>
                                        <div className="carousel-item"><img className="responsive-img" src={AzureImage1} alt="JetMinds Microsoft Azure" loading="lazy" /></div>
                                        <div className="carousel-item"><img className="responsive-img" src={AzureImage2} alt="JetMinds Microsoft Azure" loading="lazy" /></div>
                                        <div className="carousel-item"><img className="responsive-img" src={AzureImage3} alt="JetMinds Microsoft Azure" loading="lazy" /></div>
                                        <div className="carousel-item"><img className="responsive-img" src={AzureImage4} alt="JetMinds Microsoft Azure" loading="lazy" /></div>
                                        <div className="carousel-item"><img className="responsive-img" src={AzureImage5} alt="JetMinds Microsoft Azure" loading="lazy" /></div>
                                    </div>
                                </div>
                            </div>
                        </div>} */}
                    <div className="section">
                        <div className="row center">
                            <div className="col s12 m12">
                                <a href="/kontakt" className="btn-large orange darken-4">Zur Kontaktanfrage<i className="material-icons right" style={{ fontSize: "20px" }}>arrow_forward</i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </ React.Fragment >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/layout/pages/Azure.js